import React from 'react';
import { matchPath, Route, withRouter } from 'react-router-dom';
import CacheRoute, { CacheSwitch } from 'react-router-cache-route';
import { createBundle } from 'widget/Common';
import {
  consumeRefreshOnNextRecover,
  getRouteCacheConfig,
  getRouteCacheName,
  getRouteCacheVersion,
  isRouteCacheEnabled,
  subscribeRouteCache
} from './routeCache';
import ErrorDemoH5 from 'bundle-loader?lazy&name=ErrorDemoH5!pages/ErrorDemo';
// 报错测试页面
import ErrorDemo from 'bundle-loader?lazy&name=ErrorDemo!biz-micro-services-ui/project/middlePlatform/pages/errorDemo';
// 页面找不到组件
import NotFound from 'bundle-loader?lazy&name=NotFoundView!widget/NotFound/NotFoundView';
// 默认首页
import ShopHomeView from 'pages/Shop/Home/ShopHome/ShopHomeView';
// AI图文详情（改为懒加载）
import AIImageTextView from 'bundle-loader?lazy&name=AIImageTextView!pages/AICreation/AIImageText/AIImageTextView';
// AI视频详情（改为懒加载）
import AiVideoDetailView from 'bundle-loader?lazy&name=AiVideoDetailView!pages/AICreation/AiVideoDetail/AiVideoDetailView';

// 注册
import RegisterRouterConfig from 'pages/Register/RouterConfig';
// 登录
import LoginRouterConfig from 'pages/Login/RouterConfig';
// 商城
import ShopRouterConfig from 'pages/Shop/RouterConfig';
// 展业
import PromoteRouterConfig from 'pages/Promote/RouterConfig';
// 分享
import ShareRouterConfig from 'pages/Share/RouterConfig';
// 店铺
import StoreRouterConfig from 'pages/Store/RouterConfig';
// 学习
import LearnRouterConfig from 'pages/Learn/RouterConfig';
// 下载app
import DownLoadConfig from 'pages/DownLoad/RouterConfig';

// 打卡
import PunchClickRouterConfig from 'pages/PunchClock/RouterConfig';

// 查看文件（改为懒加载）
import FileSeeView from 'bundle-loader?lazy&name=FileSeeView!pages/FileSee/FileSeeView';

import MapRouterConfig from 'pages/Map/RouterConfig';
// 中间跳转页面（改为懒加载）
import TransitView from 'bundle-loader?lazy&name=TransitView!pages/Transit/TransitView';
// iOS AI 智能体桌面快捷图标中转页
import AiAgentShortcutView from 'bundle-loader?lazy&name=AiAgentShortcutView!pages/AiAgentShortcut/AiAgentShortcutView';

const routerList = [
  {
    path: '/',
    // // 直接渲染内容，用render
    // render: () => {
    //   return <h3>默认首页</h3>
    // }
    // 首页不做懒加载，减少首屏时间
    title: '首页',
    cacheName: '/shop/home',
    component: () => ShopHomeView
  },
  {
    path: '/shop/home',
    // // 直接渲染内容，用render
    // render: () => {
    //   return <h3>默认首页</h3>
    // }
    // 懒加载组件，用component，且组件使用createBundle包裹
    title: '首页',
    component: () => ShopHomeView
  },
  {
    path: '/aiCreation/aiImageText/AIImageTextDetail',
    title: 'AI图文',
    component: () => createBundle(AIImageTextView)
  },
  {
    path: '/aiCreation/aiVideoDetail',
    title: 'AI视频详情',
    component: () => createBundle(AiVideoDetailView)
  },
  {
    path: '/fileSee',
    title: '查看文件',
    component: () => createBundle(FileSeeView)
  },
  {
    path: '/ErrorDemo',
    title: '报错测试',
    component: () => ErrorDemo
  },
  {
    path: '/ErrorDemoH5',
    title: '报错测试H5',
    component: () => ErrorDemoH5
  },
  {
    path: '/transit',
    title: '中间跳转页面',
    component: () => createBundle(TransitView)
  },
  {
    path: '/aiAgentShortcut',
    title: 'AI智能体快捷方式',
    component: () => createBundle(AiAgentShortcutView)
  },

  ...RegisterRouterConfig,
  ...LoginRouterConfig,
  ...ShopRouterConfig,
  ...PromoteRouterConfig,
  ...ShareRouterConfig,
  ...StoreRouterConfig,
  ...LearnRouterConfig,
  ...DownLoadConfig,
  ...PunchClickRouterConfig,
  ...MapRouterConfig
];

function getMatchedRoute(pathname) {
  return routerList.find((route) => {
    if (!route || !route.path) return false;

    return matchPath(pathname, {
      path: route.path,
      exact: true
    });
  });
}

class RouterView extends React.Component {
  state = {
    cacheVersion: 0
  };

  componentDidMount() {
    // 白名单变化后刷新路由渲染，让新增/删除缓存立即生效。
    this.unsubscribeRouteCache = subscribeRouteCache(() => {
      this.setState(({ cacheVersion }) => ({
        cacheVersion: cacheVersion + 1
      }));
    });
  }

  componentWillUnmount() {
    this.unsubscribeRouteCache && this.unsubscribeRouteCache();
  }

  componentDidUpdate(prevProps) {
    const { location: prevLocation } = prevProps;
    const { location: currentLocation } = this.props;
    if (
      prevLocation.pathname == currentLocation.pathname &&
      prevLocation.search == currentLocation.search
    ) {
      return;
    }

    const route = getMatchedRoute(currentLocation.pathname);
    const routeName = getRouteCacheName(route);
    if (routeName && isRouteCacheEnabled(route)) {
      consumeRefreshOnNextRecover(routeName);
    }
  }

  renderRoute = (route, idx) => {
    if (location.hash == `#${route.path}`) {
      // 写死“有享云商”，不取route的title，是为了兼容微信、钉钉等不可动态改变title的问题
      // document.title = '有享云商1111' || route.title || '';
    }

    const routeName = getRouteCacheName(route);
    const routeComponent = route.render || route.component();
    // route.cache 或手动白名单命中时启用 CacheRoute，其余路由继续保持普通 Route。
    const RouteComponent = routeName && isRouteCacheEnabled(route) ? CacheRoute : Route;
    const cacheProps = RouteComponent == CacheRoute ? getRouteCacheConfig(route) : {};
    const routeKey =
      RouteComponent == CacheRoute
        ? `route_${idx}_${getRouteCacheVersion(routeName)}`
        : `route_${idx}`;

    return (
      <RouteComponent
        key={routeKey}
        path={route.path}
        exact
        component={routeComponent}
        {...cacheProps}
      />
    );
  };

  render() {
    return (
      <div style={{ height: '100%' }}>
        <CacheSwitch>
          {routerList.map(this.renderRoute)}
          <Route component={createBundle(NotFound)} />
        </CacheSwitch>
      </div>
    );
  }
}

const CacheRouterView = withRouter(RouterView);

const getRouter = () => <CacheRouterView />;

export { getRouter, routerList };



// WEBPACK FOOTER //
// ./src/router/index.js